import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Popover } from 'antd';
import moment from 'moment';

import { AppDispatch, RootState } from 'store';

import { MAIN_ROUTER } from 'routers/constants';
import {
  deleteRequest,
  getRequest,
  postRequest
} from 'services/request';
import { endpointBase } from 'services/endpoints';

import { BellOutlined } from '@ant-design/icons';

import { G14 } from 'helpers/data/user';

import * as S from './Notification';
import { getNotifications, getUnreadNotifications } from 'store/slice/common';
import { patchRequest } from 'services/request/patchRequest';

export default function Notification() {
  const { t } = useTranslation('notification');

  const navigator = useNavigate();

  const { unreadNotificationsCount, listNotifications } = useSelector(
    (state: RootState) => state.common
  );
  const { userInfo } = useSelector((state: RootState) => state.auth);

  const [openNotification, setOpenNotification] = useState<boolean>(false);
  const [list, setList] = useState<any[]>([]);
  const [countUnread, setCountUnread] = useState<number>(0);

  const handleReadAll = () => {
    // if (list?.length > 0) {
    //   postRequest(`${endpointBase.NOTIFICATION}/consume`).then(() => {
    //     if (userInfo?.ou?.length > 0) {
    //       if (userInfo?.ou === G14) {
    //         dispatch(getNotifications({}));
    //       } else {
    //         dispatch(
    //           getNotifications({ filter: `{codeOrg:'${userInfo?.ou}'}` })
    //         );
    //       }
    //       setOpenNotification(false);
    //     }
    //   });
    // }
  };

  const getList = async () => {
    if (userInfo?.ou?.length > 0) {
      let filter: any = {};
      if (userInfo?.ou !== G14) {
        filter.codeOrg = userInfo?.ou;
      } else {
        delete filter.codeOrg;
      }

      getRequest(endpointBase.NOTIFICATION, {
        params: { count: true, filter: filter }
      })
        .then((res: any) => {
          setList(
            res?._embedded?.map((item: any) => ({
              ...item,
              key: item?._id?.$oid
            }))
          );
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const getUnreadList = async () => {
    if (userInfo?.ou?.length > 0) {
      let filter: any = {};
      if (userInfo?.ou !== G14) {
        filter.codeOrg = userInfo?.ou;
      } else {
        delete filter.codeOrg;
      }

      getRequest(endpointBase.NOTIFICATION, {
        params: { count: true, filter: filter }
      })
        .then((res: any) => {
          setCountUnread(res?._size);
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    getList();
    getUnreadList();
  }, [userInfo]);

  const handleUpdate = (item: any) => {
    if (item?.status === 0) {
      patchRequest(`${endpointBase.NOTIFICATION}/${item?._id?.$oid}`, {
        data: { status: 1 }
      });
      getList();
    }
  };

  const contentNotification = (
    <S.WrapperListNotification className="open">
      <S.WrapperTitle>
        <S.Title>
          {t('notification')} ({unreadNotificationsCount || 0})
        </S.Title>
        {/* <S.SectionMardRead>
          <S.BtnActionNotification onClick={handleReadAll}>
            {t('markReadAll')}
          </S.BtnActionNotification>
        </S.SectionMardRead> */}
      </S.WrapperTitle>
      <S.SectionList>
        {list?.slice(0, 5)?.map((item: any) => (
          <S.CardWrap
            $isRead={parseInt(item?.status) === 1}
            key={item?.notification_id}
            onClick={() => handleUpdate(item)}
          >
            <S.ContentWrap>
              <S.TitleNor className="nor-title">{item?.title}</S.TitleNor>
              {item?.url && (
                <S.Content className="nor-content">Url: {item?.url}</S.Content>
              )}
              <S.Content>
                {moment(new Date(item?.updatedAt?.$date)).format(
                  'DD/MM/YYYY hh:mm:ss'
                )}
              </S.Content>
            </S.ContentWrap>

            {item?.status !== 1 && <S.MaskRead />}
          </S.CardWrap>
        ))}
      </S.SectionList>
      <S.WrapperFooter>
        <S.BtnActionNotification
          onClick={() => {
            navigator(MAIN_ROUTER.NOTIFICATION);
            setOpenNotification(false);
          }}
        >
          {t('viewAllNotification')}
        </S.BtnActionNotification>
      </S.WrapperFooter>
    </S.WrapperListNotification>
  );

  return (
    <S.Wrapper>
      <Popover
        open={openNotification}
        content={contentNotification}
        trigger="click"
        placement="bottom"
        overlayInnerStyle={{ maxWidth: '90vw', padding: '0px' }}
        arrow={false}
        onOpenChange={() => setOpenNotification(!contentNotification)}
      >
        <S.BtnActionNotification
          onClick={() => setOpenNotification(!openNotification)}
        >
          <Badge
            size="small"
            count={
              unreadNotificationsCount > 9 ? '9+' : unreadNotificationsCount
            }
          >
            <BellOutlined
              onClick={() => setOpenNotification(() => !openNotification)}
            />
          </Badge>
        </S.BtnActionNotification>
      </Popover>
    </S.Wrapper>
  );
}
